<template>
    <section class="myIndex">
      <div class="topWrap">
        <div class="info">
          <img class="avatar l" :src="getAvatar" alt="">
          <h2 class="f48 bold customerName">{{customerInfo.weChatNickName?customerInfo.weChatNickName:'包府游客'}}</h2>
          <h3 class="grey6 f28">{{customerInfo.mobile}}</h3>
        </div>
        <ul class="t_center">
          <li  @click="toView('vipRecharge')">
            <h4>{{customerInfo.balance}}</h4>
            <div style='margin-top:4px'>余额</div>
          </li>
          <li  @click="toView('couponList')">
            <h4>{{customerInfo.couponQuantity}}</h4>
            <div style='margin-top:4px'>优惠券</div>
          </li>
          <!-- <li  @click="clearSsion">
            <div style='margin-top:4px'>清楚缓存</div>
          </li> -->
        </ul>
      </div>
      <!--功能栏-->
      <div class="midWrap">
        <div class="banner"  @click="toView('vipRecharge')">
          <img src="/images/my/index_banner_01.png" alt="middle">
        </div>
        <ul class="grey6 f22">
          <li class="t_center" v-for="(item, index) in functionBar" :key="index"  @click="toView(item.pathName,item.name)">
            <img :src="'/images/my/'+item.icon+'.png'" align="middle">
            <div>{{item.name}}</div>
          </li>
        </ul>
      </div>
      <!--菜单栏-->
      <div class="botWrap">
        <ul class="f28">
          <li v-for="(item, index) in menuBar" :key="index" @click="toView(item.pathName)" :class='{borNone:index == (menuBar.length -1)}'>
            <!-- <div v-if="item.pathName=='kefu'"  id="alldo" style=""></div> -->
            <img :src="'/images/my/'+item.icon+'.png'" align="middle">
            <p>{{item.name}}</p>
          </li>
        </ul>
        
      </div>

      <div class="botWrap" style='margin-top:10px;'>
        <ul class="f28">
          <li @click='logOut' style='border-bottom:none!important'>
            <img :src="'/images/my/index_icon_101.png'" align="middle">
            <p>退出</p>
          </li>
        </ul>
        
      </div>

      <transition name="van-fade">
        <div class='markShdow' @click='showKefu = false' v-if='showKefu'>
          <div>
            <img src="/images/base/weChart.png" align="middle">
            <div  class="qrcode-wrap">

              <img :src="dataUrl" alt="" />
            </div>
          </div>
        </div>
      </transition>

      <!-- <button class="primary" size="large" @click='logOut'>退出</button> -->
    </section>
</template>

<script>
  import { mapState } from 'vuex'
  import myApi from '@/axios/my'
  import { Dialog,Toast } from 'vant';
  import loginApi from '@/axios/login'
  import publicObj from '@/assets/js/public'
  import getWXConfig from "@/assets/js/wx.config";
  import zhugeObj from "@/assets/js/track";
  import QRCode from 'qrcode';
  export default {
    name: 'myIndex',
    data () {
      return {
        isCall:false,
        functionBar: [
          { name: '会员充值', pathName: 'vipRecharge', icon: 'index_icon_01' },
          { name: '包拯达人', pathName: 'feedback', icon: 'index_icon_02' },
          { name: '已购服务', pathName: 'purchasedServices', icon: 'index_icon_03' }
        ],
        menuBar: [
          { name: '我的地址', pathName: 'addressList', icon: 'index_icon_04' },
          { name: '在线咨询', pathName: 'kefu', icon: 'index_icon_05' },
          { name: '电话咨询', pathName: '', icon: 'index_icon_06' },
          { name: '协议与条款说明', pathName: 'agreementDoc', icon: 'index_icon_100' }
        ],
        customerInfo : {

        },
        showKefu: false,
        dataUrl: ''
      }
    },
    component: {
      mapState
    },
    watch: {},
    computed: {
      setServicePhone() {
          return this.$store.state.servicePhone
      },
      getAvatar () {
        return this.customerInfo ? (this.customerInfo.headImgUrl || this.DEFAULT_AVATAR) : this.DEFAULT_AVATAR
      },
      customerId(){
        return this.$store.state.customerId;
      }
    },
    created () {
      this.getBaseInfo();
      this.getCustomerServiceTime()
      zhugeObj.track({
            title: "我的页曝光"
        });
    },
    mounted () {
      this.getEwm()
      zhuge.identify(this.customerId);
      getWXConfig()
      // var dom = document.getElementById('alldo') //
      // let urlend = encodeURIComponent(window.location.href)
      // dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?h5Url='+urlend+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:500px;height:90px;"></div></template></wx-open-launch-weapp>'
  
      // var launchBtn = document.getElementById('launch-btn')
      // if (!launchBtn) {
      // return
      // }
      // launchBtn.addEventListener('launch', function (e) {
      //   zhugeObj.track({
      //       title: "个人中心-在线咨询-点击"
      //   });
      // })
      // launchBtn.addEventListener('error', function (e) {
      // console.log('fail', e.detail)
      // })
    },
    methods: {
      getEwm() {
        QRCode.toDataURL(publicObj.byCustomerIdCreateQRcode(this.setServicePhone))
          .then(res=>{
              this.dataUrl = res
          })
      },
      clearSsion(){
        localStorage.removeItem(publicObj.openId)
        localStorage.removeItem(publicObj.unionId)
        // alert(!!localStorage.getItem(publicObj.openId),!!localStorage.removeItem(publicObj.unionId))
      },
      logOut(){
          const _this =this;
          Dialog.confirm({
            title: '提示',
            message: '是否确定要退出？',
          }).then(() => {
            // on confirm

             if(publicObj.isWeiXin()){
                  loginApi.unbindWechat().then(res=>{
                      _this.clearUserInfo()
                  }).catch(()=>{
                    _this.clearUserInfo()
                  })
              }else {
                  _this.clearUserInfo()
              }
          }).catch(() => {
            // on cancel
          });
      },
      clearUserInfo(){
          this.$store.commit('setUserInfo',{});
          localStorage.clear();
          sessionStorage.clear();
          location.replace(location.origin)
      },
      getBaseInfo(){
        myApi.customerInfo().then((res)=>{
          this.customerInfo = res;
        })
      },
      getCustomerServiceTime(){
        myApi.getCustomerServiceTime().then((res)=>{
          this.isCall = res
        })
      },
      toView (pathName,name) {
        const _this = this
        if(pathName == 'agreement'){
          this.$router.push({ name: pathName ,query:{type:'three'}});
          return;
        }
        if(name == '包拯达人'){
          Toast('功能紧急开发中，敬请期待！');
          return;
        }
        if(pathName=='kefu'){
          this.showKefu = true;
          return
        }
         
        if (pathName) {
          this.$router.push({ name: pathName })
        } else {
          if(this.isCall){
            location.href = 'tel:' + _this.$store.state.keFuTel
            // Dialog.confirm({
            //   title: '提示',
            //   message: '确定拨打电话：4000528吗？',
            // }).then(() => {
            //   alert(333)
            //   location.href = 'tel:' + _this.$store.state.keFuTel
            // }).catch(() => {
            //   // on cancel
            // });
          }else{
            Dialog.alert({
              message: '客服休息中',
              message: '请于 9:00 - 21:00 进行拨打',
              confirmButtonText:'我知道了',
              theme: 'round-button',
            }).then(() => {
            }).catch(() => {
              // on cancel
            });
            
          }
          
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.customerName{
    overflow: hidden;/*超出部分隐藏*/
    text-overflow:ellipsis;/* 超出部分显示省略号 */
    white-space: nowrap;/*规定段落中的文本不进行换行 */
}
.borNone{
  border:none!important; 
}
.myIndex{
  padding-bottom: 150px;
  .topWrap{
    height:376px;
    padding: 0 20px;
    background:url("/images/my/index_top_wrap.png") no-repeat left -20px;
    background-size: 100%;
    .info{
      height: 250px;
      box-sizing: border-box;
      padding: 56px 36px 0;
      .avatar{
        width: 130px;
        height: 130px;
        border: 4px $primary-color solid;
        border-radius: 50%;
        margin-right: 34px;
      }
      h2{
        padding: 10px 0 8px;
        line-height: 66px;
      }
      h3{
        line-height: 40px;
      }
    }
    ul{
      display: flex;
      padding-top: 20px;
      li{
        flex: 1;
        h4{font-weight: bold;font-size: 36px}
        div{
          color: $light-grey;font-size: 24px;line-height: 34px;
        }
      }
    }
  }
  .midWrap{
    height:320px;
    padding: 0 20px;
    background:url("/images/my/index_mid_wrap.png") no-repeat left -20px;
    background-size: 100%;
    .banner{
      height: 140px;
      border-radius:6px 6px 0 0;
      img{
        width: 100%;
      }
    }
    ul{
      display: flex;
      position: relative;
      li{
        height: 122px;
        padding-top: 38px;
        flex: 1;
        line-height: 44px;
        img{
          width: 80px;
        }
      }
    }
  }
  .botWrap{
    // height:464px;
    margin: 0 20px;
    padding: 0 30px;
    border-radius: 6px;
    box-shadow:$base-shadow;
    ul{
      padding: 2px 4px 38px;
      padding-bottom:0px;
      li{
        padding: 28px 0 28px 64px;
        border-bottom: 2px $border-color dashed;
        background:url("/images/public/arrow_right.png")  no-repeat  right center;
        background-size:12px ;
        position: relative;
        img{
          width: 36px;
          position: absolute;
          left: 8px;
          top:26px
        }
        p{line-height: 40px;}
      }
    }
  }
}
#alldo{
  position:absolute;width:100%;height:90px;left:0px;top:5px;
}
.markShdow{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    text-align: center;
    background: rgba(0,0,0,.8);
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .markShdow div {
      width: 100%;
      position: relative;
      margin-top:200px;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column-reverse;
      flex-direction: column-reverse;
  }
  .markShdow div>img{
      width: 100%;
  }
  .markShdow div .qrcode-wrap {
      position: absolute;
      bottom: 15px;
      width: 280px;
      height: 280px;
      background: red;
      left: 50%;
      margin-left:-140px;
  }
</style>
